export function setItem(key: string, value: any) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error('Storage setItem error: ', error);
  }
}

export function getItem(key: string) {
  let value = null;

  try {
    const data = localStorage.getItem(key);
    if (data) {
      value = JSON.parse(data);
    }
  } catch (error) {
    console.error('Storage getItem error: ', error);
  }

  return value;
}

export function removeItem(key: string) {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Storage removeItem error: ', error);
  }
}
